export type SubAgentStatus =
  | "running"
  | "needs_input"
  | "idle"
  | "failed"
  | "stopped";

export type SubAgentResult =
  | {
      status: "idle" | "failed" | "stopped";
      workflowId: string;
      workflowUrl?: string;
      branchId?: string;
      summary: string;
      // Keep the user’s pause decision through delivery retries.
      pauseAfter?: boolean;
      answered?: {
        tool: string;
        entryId: string;
        branchId?: string;
        input?: unknown;
        output?: unknown;
        outputBlobId?: string;
      };
    }
  | {
      status: "needs_input";
      workflowId: string;
      workflowUrl?: string;
      branchId?: string;
      pending: { entryId: string; tool: string; input: unknown };
    };

export const SUB_AGENT_WAIT_TOOLS: ReadonlySet<string> = new Set([
  "startWorkflowAgent",
  "messageWorkflowAgent",
  "answerWorkflowAgent",
]);

// Pauses only the user can resolve; the personal chat prompts for them while the parent keeps waiting.
export const SUB_AGENT_USER_TOOLS: ReadonlySet<string> = new Set([
  "askQuestion",
  "pushLive",
  "connectStepToApp",
  "connectChatToApp",
]);

export const SUB_AGENT_UPDATE_PREFIX = "Workflow agent update: ";

export const WORKFLOW_FOCUS_PREFIX = "The user is focused on workflow ";

const UPDATE_VERBS: Record<SubAgentResult["status"], string> = {
  idle: "finished",
  needs_input: "needs input",
  failed: "failed",
  stopped: "stopped",
};

export function subAgentUpdateText(name: string, outcome: SubAgentResult) {
  return `${SUB_AGENT_UPDATE_PREFIX}${name} ${UPDATE_VERBS[outcome.status]}\n${JSON.stringify(outcome)}`;
}
